import gql from 'graphql-tag';







const getContractsQuery = gql`
  query getContracts(
    $organisationId: String!,
    $product: String,
    $status: String
  ) {
    getContracts(
      organisationId: $organisationId,
      product: $product,
      status: $status
    ) {
      OrgId
      ContractId
      Type
      Status
      StartDate
      EndDate
      CreatedAt
      CreatedBy
      Payload
    }
  }
`;

export default (() => ({
  query: getContractsQuery,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: ({ organisationId, product, status }) => ({
    organisationId,
    product,
    status
  })
}));